module.exports = __webpack_public_path__ + "static/media/hashim.6c0e865c.jpg";